import { createSlice } from "@reduxjs/toolkit";
import {
  createErrorReportingAsyncThunk,
  defaultErrorAction,
} from "../../helpers";
import { notifyL } from "../../notifications";
import axios, { getData } from "../../../axios";
import * as tPromise from "io-ts-promise";
import * as t from "io-ts";
import {
  ssoIntegrationT,
  saveMicrosoftGroupAllowlistT,
  tenantGroupsT,
  MicrosoftGroup,
} from "dora-contracts";

const prefix = "data/sso-integration";

interface State {
  integration: null | t.TypeOf<typeof ssoIntegrationT>;
  tenantGroups: null | MicrosoftGroup[];
}

const initialState: State = {
  integration: null,
  tenantGroups: null,
};

export const loadSsoIntegration = createErrorReportingAsyncThunk(
  "load-sso-integration",
  async () => {
    return axios
      .get("/api/sso-integration")
      .then(getData)
      .then(tPromise.decode(ssoIntegrationT));
  }
);

export const loadTenantSecurityGroups = createErrorReportingAsyncThunk(
  "load-tenant-security-groups",
  async () => {
    return axios
      .get("/api/sso-integration/tenant-groups")
      .then(getData)
      .then(tPromise.decode(tenantGroupsT));
  }
);

export const saveSsoGroupAllowlist = createErrorReportingAsyncThunk(
  "save-sso-group-allowlist",
  async (groupIds: string[], thunkApi) => {
    try {
      await axios.post(
        "/api/sso-integration/group-allowlist",
        saveMicrosoftGroupAllowlistT.encode({ groupIds })
      );
      return groupIds;
    } catch (err: any) {
      if (err.response?.data?.error === "self_lockout") {
        thunkApi.dispatch(
          notifyL({
            namespace: "singleSignOn",
            key: "selfLockoutWarning",
            type: "error",
          })
        );
      } else {
        thunkApi.dispatch(defaultErrorAction());
      }
      throw err;
    }
  },
  { skipNotification: true }
);

const slice = createSlice({
  initialState,
  name: prefix,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadSsoIntegration.fulfilled, (state, action) => {
      state.integration = action.payload;
    });
    builder.addCase(loadTenantSecurityGroups.fulfilled, (state, action) => {
      state.tenantGroups = action.payload.groups;
    });
    builder.addCase(saveSsoGroupAllowlist.fulfilled, (state, action) => {
      if (state.integration) {
        state.integration.allowedGroupIds = action.payload;
      }
    });
  },
});

export default slice.reducer;
